import React, { Dispatch, SetStateAction, useState } from "react";
import { makeStyles, Tooltip, TextField, IconButton, InputAdornment } from "@material-ui/core";
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';
import { copyExperienceAsVariant } from "./C3Services/contentControl";
//import ErrorIcon from '@material-ui/icons/Error';
const NotificationBar   = require("editor/ui/notificationbar/NotificationBar");
const config            = require("shared/xp/config/index").default;

interface moveExperienceProps {
    baseExperienceId: string,
    collectionDetails : any;
    setAllExperienceJSON :  Dispatch<SetStateAction<any>>;
    handleChangeVariant: any
}

const useStyles = makeStyles<CreateCSSProperties>(() => ({
    textField: {
        marginLeft: "5px",
        width: "210px",
        background: "#fff",
        "& .MuiOutlinedInput-adornedEnd": {
            paddingRight: "0px"
        },
        "& .MuiInputBase-input.MuiOutlinedInput-input" : {
            paddingLeft: "0px",
            height: "20px !important",
            border: "none !important"
        }, 
        "& .MuiIconButton-root": {
            padding: "0px"
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: "0px !important",
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'white',
              },
            '&.Mui-focused fieldset': {
                borderColor: 'grey',
              }
        },
        
    },

    tooltipPopper: {
        width: "300px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important",
        textAlign: "center"
    },

    tooltipLabel: {
        backgroundColor: '#fff',
        height: "25px",
        fontSize: "1.2rem",
        fontWeight: 500,
        color: 'grey',
        margin: "0px",
        "& .MuiTooltip-arrow": {
            color: "#fff",
            "&:before": {
                border: "1px solid #343e43"
            },
        }
    },

    errorIconTooltip: {
        width: "160px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important",
        textAlign: "center"
    },


    errorIcon: {
        alignItems: "center",
        height: "20px",
        width: "17px",
        backgroundImage: "url(../../../../images/error-icon.png)",
        backgroundRepeat: "no-repeat"
    }
    
  }));

export default function  MoveExperience(props: moveExperienceProps) {
    const classes = useStyles();
    const { baseExperienceId, collectionDetails, setAllExperienceJSON , handleChangeVariant} = props;
    const [experienceIdToMove, setExperienceIdToMove] = useState<string>("");
    const [isValidC3Experience, setIsValidC3Experience] = useState<boolean>(true);
    
    const handleChange = (e:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if(e.target.value == "") {
            setExperienceIdToMove("");
            setIsValidC3Experience(true);
        } else {
            setExperienceIdToMove(e.target.value);
            setIsValidC3Experience(validateExperienceId(e.target.value));
        }
        
    }

    const validateExperienceId = (experienceId: string) => {
        // regex for a valid c3 experienceid
         return (/\C3_[a-z0-9]{21}$/).test(experienceId);
    }

    const handleMoveExperience = async() => {

        if(experienceIdToMove && isValidC3Experience) {
             // API call and then re-render the state
            const copyExperienceJSON = {
                "experienceId": experienceIdToMove,
                "collectionId": collectionDetails.id,
                "parentExperienceId": baseExperienceId
            }
            const response = await copyExperienceAsVariant(copyExperienceJSON);
            if (response.mergedExperience) {
                setAllExperienceJSON((prev: any) => ({
                    ...prev,
                    [response.mergedExperience.id]: response.mergedExperience
                }));
                handleChangeVariant(response.mergedExperience.id);
            } else if (response.languageMismatch) {
                NotificationBar.open("Language of the experience that you are trying to import should be the same as base language of current experience.", {closeDelay: 5000});
            } else if(response.message.includes("Invalid request")) {
                NotificationBar.open({message: 'You cannot move a multi-scene experience into a single-scene experience. ', action: "support community"}, {closeDelay: 5000});
            } else {
                const url = config.communityBaseUrl + "/hc/en-us/articles/201545079";
                NotificationBar.open(`No such experience could be found. <a href=${url}>Visit The Community</a>`, {closeDelay: 5000});
            }
        }
       
    };

    return(
        <>
            <Tooltip
                classes={{
                    popper: classes.tooltipPopper,
                    tooltip: classes.tooltipLabel,
                }}
                arrow
                title={"Copies the Selected Experience into this Collection"}
                TransitionProps={{ timeout: 0 }}
            >
                <button onClick={handleMoveExperience} className="move-to-experience-btn btn btn-white btn-import-action" data-original-title="" title="">Move Here</button>
            </Tooltip>

            <TextField
                className={classes.textField}
                placeholder="C3_5xxxxxxxxxxxxxxxxxxxxxxx"
                onChange={(e) => handleChange(e)}
                variant="outlined"
                InputProps={{
                    endAdornment: (
                        <InputAdornment
                        style={{ display: isValidC3Experience ? "none" : "flex"}}
                        position="start"
                        >
                            <IconButton>
                                <Tooltip
                                classes={{
                                    popper: classes.errorIconTooltip,
                                    tooltip: classes.tooltipLabel,
                                }}
                                arrow
                                TransitionProps={{ timeout: 0 }}
                                title="Not a valid Experience Id">
                                    <div 
                                    className={classes.errorIcon}>
                                    </div>
                                </Tooltip>
                                
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
             
          />
        </>
    )
}


// WEBPACK FOOTER //
// ./src/editor/ui/editor/CollectionNavigation/MoveExperience.tsx